<template>
    <div>
        <div class="badge-nfse text-center">
            <span v-if="regimeTributario.optanteSimplesNacional">Simples Nacional</span>
            <span v-else>Regime Normal</span>
        </div>
        <b-row>
            <b-col sm="2">
                <SelectStatic title="Simples Nacional" :markFormDirty="true" :required="true" :disabled="disabled"
                    :initialValue="optanteSimplesNacionalSelect" :data="optionsSimplesNacional"
                    v-model="optanteSimplesNacionalSelect" />
            </b-col>
            <b-col sm="4">
                <SelectStatic title="Regime Tributário" :markFormDirty="true" :required="true" :disabled="disabled"
                    :initialValue="regimeTributario.regimeTributario" :data="optionsRegimeTributario"
                    v-model="regimeTributario.regimeTributario" />
            </b-col>
            <b-col sm="4">
                <SelectStatic title="Regime Especial Tributação" :markFormDirty="true" :required="true" :disabled="disabled"
                    :initialValue="regimeTributario.regimeEspecialTributacao" :data="optionsRegimeTributarioEspecial"
                    v-model="regimeTributario.regimeEspecialTributacao" />
            </b-col>
            <b-col sm="2">
                <SelectStatic title="Incentivador Cultural" :markFormDirty="true" :required="true" :disabled="disabled"
                    :initialValue="incentivadorCulturalSelect" :data="optionsIncentivadorCultural"
                    v-model="incentivadorCulturalSelect" />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6">
                <SelectStatic title="Natureza da Operação" :markFormDirty="true" :required="true" :disabled="disabled"
                    :initialValue="regimeTributario.naturezaOperacao" :data="optionsNaturezaOperacao"
                    v-model="regimeTributario.naturezaOperacao" />
            </b-col>
            <b-col sm="6">
                <SelectStatic title="Código Indicador Operação" :markFormDirty="true" :required="false" :disabled="disabled"
                    :initialValue="regimeTributario.codigoIndicadorOperacao" :data="optionsCodigoIndicadorOperacao"
                    v-model="regimeTributario.codigoIndicadorOperacao" />
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="6">
                <SelectStatic title="IBS/CBS Situação Tributária" :markFormDirty="true" :required="false" :disabled="disabled"
                    :initialValue="regimeTributario.ibsCbsSituacaoTributaria" :data="optionsTributacaoIBSCBS"
                    v-model="regimeTributario.ibsCbsSituacaoTributaria" />
            </b-col>
            <b-col sm="6">
                <SelectStatic title="IBS/CBS Classificação Tributária" :markFormDirty="true" :required="false" :disabled="disabled"
                    :initialValue="regimeTributario.ibsCbsClassificacaoTributaria"
                    :data="optionsClassificacaoTributaria" v-model="regimeTributario.ibsCbsClassificacaoTributaria" />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SelectStatic from "@nixweb/nixloc-ui/src/component/forms/SelectStatic";
import OpcoesTributarias from '../shared/OpcoesTributarias.js';
import NfsePrefeitura from './NfsePrefeitura.js';
import { mapActions } from "vuex";

export default {
    name: 'RegimeTributario',
    props: ["disabled", "value"],
    components: { SelectStatic },
    data() {
        return {
            id: this.$route.params.id,
            loading: false,
            urlGetById: "/api/v1/tax-document/config-company/get-by-id",
            regimeTributario: new NfsePrefeitura().regimeTributario,
            optanteSimplesNacionalSelect: { content: 'Sim', id: true },
            incentivadorCulturalSelect: { content: 'Não', id: false },
        };
    },
    created() {
        if (!this.id) this.obterRegimeTributarioEmpresa();
    },
    computed: {
        OpcoesTributarias() {
            return OpcoesTributarias;
        },
        optionsSimplesNacional() {
            return OpcoesTributarias.optanteSimplesNacional;
        },
        optionsIncentivadorCultural() {
            return OpcoesTributarias.incentivadorCultural;
        },
        optionsNaturezaOperacao() {
            return OpcoesTributarias.naturezaOperacao;
        },
        optionsRegimeTributario() {
            let optionsFinal = [];
            let options = OpcoesTributarias.regimeTributario;

            options.forEach(option => {
                if (this.regimeTributario.optanteSimplesNacional && (option.id === '1' || option.id === '2' || option.id === '4')) {
                    optionsFinal.push(option);
                } else if (!this.regimeTributario.optanteSimplesNacional && option.id === '3') {
                    optionsFinal.push(option);

                }
            });

            return optionsFinal;
        },
        optionsRegimeTributarioEspecial() {
            const options = OpcoesTributarias.regimeTributarioEspecial;

            let optionsFinal = [{ content: 'Nenhum', id: '0' }];

            if (this.regimeTributario.optanteSimplesNacional) {
                optionsFinal.push(
                    options.find(o => o.id === '5'),
                    options.find(o => o.id === '6')
                );
            } else {
                optionsFinal.push(
                    options.find(o => o.id === '1'),
                    options.find(o => o.id === '2'),
                    options.find(o => o.id === '3'),
                    options.find(o => o.id === '4')
                );
            }

            return optionsFinal.filter(Boolean);
        },
        optionsCodigoIndicadorOperacao() {
            return OpcoesTributarias.codigoIndicadorOperacao;
        },
        optionsTributacaoIBSCBS() {
            return OpcoesTributarias.tributacaoIBSCBS;
        },
        optionsClassificacaoTributaria() {
            return OpcoesTributarias.classificacaoTributaria;
        },
    },
    methods: {
        ...mapActions("generic", ["getApi"]),
        obterRegimeTributarioEmpresa() {
            this.loading = true;
            let params = { url: this.urlGetById, obj: {} };

            this.getApi(params).then((response) => {
                if (!response.success || !response.content) return;

                const data = response.content;
                const optanteSimplesNacional = data.optanteSimplesNacional ?? data.simplesNacional;
                const regimeEspecialTributacao = data.regimeEspecialTributacao ?? data.regimeTributarioEspecial;

                this.regimeTributario = {
                    ...this.regimeTributario,
                    optanteSimplesNacional: !!optanteSimplesNacional,
                    regimeTributario:
                        this.optionsRegimeTributario.find(x => x.id == String(data.regimeTributario)) || this.regimeTributario.regimeTributario,
                    regimeEspecialTributacao:
                        this.optionsRegimeTributarioEspecial.find(x => x.id == String(regimeEspecialTributacao)) || this.regimeTributario.regimeEspecialTributacao,
                    incentivadorCultural: !!data.incentivadorCultural,
                    naturezaOperacao:
                        this.optionsNaturezaOperacao.find(x => x.id == String(data.naturezaOperacao)) || this.regimeTributario.naturezaOperacao,
                    codigoIndicadorOperacao:
                        this.optionsCodigoIndicadorOperacao.find(x => x.id == data.codigoIndicadorOperacao)
                        || { content: "Nenhum", id: "0" },
                    ibsCbsSituacaoTributaria:
                        this.optionsTributacaoIBSCBS.find(x => x.id == data.ibsCbsSituacaoTributaria)
                        || { content: "Nenhum", id: "0" },
                    ibsCbsClassificacaoTributaria:
                        this.optionsClassificacaoTributaria.find(x => x.id == data.ibsCbsClassificacaoTributaria)
                        || { content: "Nenhum", id: "0" },
                };

                this.optanteSimplesNacionalSelect = this.regimeTributario.optanteSimplesNacional
                    ? { content: 'Sim', id: true }
                    : { content: 'Não', id: false };

                this.incentivadorCulturalSelect = this.regimeTributario.incentivadorCultural
                    ? { content: 'Sim', id: true }
                    : { content: 'Não', id: false };
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    watch: {
        value: {
            deep: true,
            immediate: true,
            handler(value) {
                if (!value) return;
                if (value === this.regimeTributario) return;

                this.regimeTributario = {
                    ...this.regimeTributario,
                    ...value,
                };

                this.optanteSimplesNacionalSelect = this.regimeTributario.optanteSimplesNacional
                    ? { content: 'Sim', id: true }
                    : { content: 'Não', id: false };

                this.incentivadorCulturalSelect = this.regimeTributario.incentivadorCultural
                    ? { content: 'Sim', id: true }
                    : { content: 'Não', id: false };
            }
        },
        optanteSimplesNacionalSelect: {
            deep: true,
            handler(value) {
                this.regimeTributario.optanteSimplesNacional = value?.id === true || value?.id === 'true';

                if (this.regimeTributario.optanteSimplesNacional) {
                    this.regimeTributario.regimeTributario = { content: 'Simples Nacional', id: '1' };
                } else {
                    this.regimeTributario.regimeTributario = { content: 'Regime Normal', id: '3' };
                }
            }
        },
        incentivadorCulturalSelect: {
            deep: true,
            handler(value) {
                this.regimeTributario.incentivadorCultural = value?.id === true || value?.id === 'true';
            }
        },
        regimeTributario: {
            deep: true,
            handler(newVal) {
                this.$emit('input', newVal);
            }
        }
    }
};
</script>

<style scoped>
.badge-nfse {
    background-color: #D98621;
    color: white;
    padding: 10;
    border-radius: 20px;
    width: 150px;
    font-size: 12px;
    margin-bottom: 20px;
}
</style>
